/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationsControllerFindOne } from "./notificationsControllerFindOne";
import { notificationsControllerGetMyNotifications } from "./notificationsControllerGetMyNotifications";
import { notificationsControllerMarkAllAsRead } from "./notificationsControllerMarkAllAsRead";
import { notificationsControllerMarkAsRead } from "./notificationsControllerMarkAsRead";

export function notificationsService() {
  return { notificationsControllerGetMyNotifications, notificationsControllerMarkAsRead, notificationsControllerFindOne, notificationsControllerMarkAllAsRead }
}